
export const en = {
  nav: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    blog: 'Blog',
    contact: 'Contact',
    language: 'Language'
  },
  header: {
    search: 'Search...',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    account: 'Account'
  },
  auth: {
    login: 'Login',
    register: 'Register',
    fullName: 'Full Name',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    enterFullName: 'Enter your full name',
    enterEmail: 'Enter your email address',
    enterPassword: 'Enter your password',
    confirmPasswordPlaceholder: 'Confirm your password',
    loginButton: 'Login',
    registerButton: 'Register',
    processing: 'Processing...',
    noAccount: 'Don\'t have an account?',
    hasAccount: 'Already have an account?',
    loginLink: 'Login',
    registerLink: 'Register',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    invalidCredentials: 'Invalid email or password',
    emailExists: 'This email address is already in use',
    generalError: 'An error occurred, please try again'
  },
  hero: {
    title: 'Advance Your Career with Professional Certificates',
    subtitle: 'Get internationally recognized certificates with IQCERT and make a difference in the business world. Achieve success with our expert trainers and quality training programs.',
    cta: 'Browse Certificates',
    watchVideo: 'Watch Intro Video'
  },
  // Navigation
  "nav.home": "Home",
  "nav.about": "About", 
  "nav.services": "Services",
  "nav.blog": "Blog",
  "nav.contact": "Contact",
  "nav.language": "Language",

  // Hero Section
  "hero.title": "Professional Certificate Training",
  "hero.subtitle": "Get the certificates you need to advance your career",
  "hero.description": "Develop your skills with online certificate programs from expert instructors and make a difference in your career.",
  "hero.cta": "Explore Courses",
  "hero.watch": "Watch Intro Video",

  // Services Section
  "services.title": "Certificate Programs",
  "services.subtitle": "Quality training from expert instructors in their field",
  "services.it.title": "Information Technologies",
  "services.it.description": "Professional certificate programs in software development, data analysis and cybersecurity.",
  "services.business.title": "Business Management",
  "services.business.description": "Certificate programs from expert instructors in project management, leadership and business development.",
  "services.design.title": "Design and Creativity",
  "services.design.description": "Creative certificate programs in graphic design, UI/UX and digital marketing.",
  "services.language.title": "Language Training",
  "services.language.description": "Internationally valid certificate programs in English, German and other foreign languages.",

  // About Section
  "about.title": "Why Choose Us?",
  "about.subtitle": "We have provided certificates to thousands of students with over 10 years of experience",
  "about.expert.title": "Expert Instructors",
  "about.expert.description": "Get quality education from experienced and certified instructors",
  "about.flexible.title": "Flexible Learning",
  "about.flexible.description": "Join training at your own pace, anytime and anywhere",
  "about.certificate.title": "Valid Certificates",
  "about.certificate.description": "Strengthen your career with internationally recognized certificates",
  "about.support.title": "24/7 Support",
  "about.support.description": "We are always with you during your learning process",
  "about.tagline": "IQCERT Certification",
  "about.certificates.badge": "Internationally Valid Certificates",
  "about.certificates.badgeDesc": "ISO 9001, ISO 14001, HACCP, SCC and more",

  // Blog Section
  "blog.title": "Latest Articles",
  "blog.subtitle": "Current content about education and career development",
  "blog.readMore": "Read More",
  "blog.post1.title": "The Importance of Certificate Training in the Digital Age",
  "blog.post1.excerpt": "In today's rapidly developing technology, continuous learning and self-improvement is no longer a luxury, but a necessity.",
  "blog.post1.author": "Dr. Mehmet Yılmaz",
  "blog.post1.date": "December 15, 2024",
  "blog.post1.category": "Education",
  "blog.post2.title": "The Role of Certificates in Career Development",
  "blog.post2.excerpt": "Which certificates should you get to stand out in the business world? Expert advice and success stories.",
  "blog.post2.author": "Ayşe Demir",
  "blog.post2.date": "December 12, 2024",
  "blog.post2.category": "Career",
  "blog.post3.title": "10 Tips for Success in Online Education",
  "blog.post3.excerpt": "Strategies and recommendations you should apply to get maximum efficiency from online training.",
  "blog.post3.author": "Prof. Dr. Ali Kaya",
  "blog.post3.date": "December 10, 2024",
  "blog.post3.category": "Tips",

  // News Section
  "news.title": "News & Announcements",
  "news.subtitle": "Latest news from the industry and important announcements",

  // Info Banners
  "info.students": "Active Students",
  "info.courses": "Certificate Programs",
  "info.instructors": "Expert Instructors",
  "info.satisfaction": "Satisfaction Rate",

  // Footer
  "footer.description": "Advance your career with professional certificate training",
  "footer.quickLinks": "Quick Links",
  "footer.programs": "Programs",
  "footer.support": "Support",
  "footer.contact": "Contact",
  "footer.phone": "Phone",
  "footer.email": "Email",
  "footer.address": "Address",
  "footer.rights": "All rights reserved",

  // Common
  "common.learnMore": "Learn More",
  "common.getStarted": "Get Started",
  "common.viewAll": "View All",
  "common.loading": "Loading...",
  "common.error": "An error occurred",
  "common.success": "Success",

  // Services Pages
  "services.belgelendirme.title": "Certification Services",
  "services.belgelendirme.subtitle": "Sustainable Tourism, GSTC Certificate, Personnel and Vegan Certification",
  "services.belgelendirme.description": "As IQCERT, we provide certification services in accordance with international standards in different sectors. We serve with our expert team in sustainable tourism, personnel competencies and special certification areas.",
  "services.belgelendirme.sustainable": "Sustainable Tourism",
  "services.belgelendirme.gstc": "GSTC Certificate",
  "services.belgelendirme.personnel": "Personnel Certification",
  "services.belgelendirme.vegan": "Vegan Certification",

  "services.yonetim.title": "Management Systems Certification",
  "services.yonetim.subtitle": "ISO Standards and Management Systems Certification Services",
  "services.yonetim.description": "We provide certification services in accordance with ISO standards in areas such as quality, environment, occupational health and safety, energy management.",
  "services.yonetim.iso9001": "ISO 9001 Quality Management System",
  "services.yonetim.iso14001": "ISO 14001 Environmental Management System",
  "services.yonetim.iso45001": "ISO 45001 Occupational Health and Safety",
  "services.yonetim.iso50001": "ISO 50001 Energy Management System",
  "services.yonetim.iso10002": "ISO 10002 Customer Satisfaction Management",
  "services.yonetim.iso27001": "ISO 27001 Information Security Management",
  "services.yonetim.iso27701": "ISO 27701 Personal Data Protection",
  "services.yonetim.iso31000": "ISO 31000 Risk Management System",
  "services.yonetim.iso39001": "ISO 39001 Road Traffic Safety",
  "services.yonetim.iso28001": "ISO 28001 Supply Chain Security",
  "services.yonetim.iso22301": "ISO 22301 Business Continuity Management",

  "services.teknik.title": "Technical Inspections",
  "services.teknik.subtitle": "Elevator, escalator and technical equipment inspections",
  "services.teknik.description": "We provide periodic inspection and examination services for the safe operation of technical equipment.",
  "services.teknik.elevator": "Elevator Periodic Inspection",
  "services.teknik.escalator": "Escalator Periodic Inspection",
  "services.teknik.photovoltaic": "Photovoltaic Inspections",
  "services.teknik.equipment": "Work Equipment Inspections",

  "services.denetim.title": "Audit and Surveillance Services",
  "services.denetim.subtitle": "Pre-loading surveillance, second party audit and hygiene inspections",
  "services.denetim.description": "We provide comprehensive audit and surveillance services for product quality and process safety.",
  "services.denetim.preloading": "Pre-loading Surveillance",
  "services.denetim.secondparty": "Second Party Audit",
  "services.denetim.hygiene": "Hygiene and Sanitation",

  "services.enerji.title": "Energy Efficiency",
  "services.enerji.subtitle": "Energy identity certificate, study and consultancy services",
  "services.enerji.description": "We provide expert consultancy and certification services on energy saving and efficiency.",
  "services.enerji.certificate": "Energy Identity Certificate",
  "services.enerji.study": "Energy Study",
  "services.enerji.consulting": "Energy Efficiency Consultancy",
  "services.enerji.zerowaste": "Zero Waste Process Management",

  "services.ozel.title": "Special Audits",
  "services.ozel.subtitle": "School, green building, hotel and sports safety audits",
  "services.ozel.description": "We provide security and quality audit services for special sectors.",
  "services.ozel.school": "School Safety",
  "services.ozel.green": "Green Building",
  "services.ozel.hotel": "Hotel Audits",
  "services.ozel.sports": "Sports Safety",

  // ISO Standards Details
  "iso.9001.description": "Quality management system standard that increases customer satisfaction",
  "iso.9001.benefits.1": "Increased customer satisfaction",
  "iso.9001.benefits.2": "Process efficiency",
  "iso.9001.benefits.3": "Reduction in error rates",
  "iso.9001.benefits.4": "Continuous improvement culture",

  "iso.14001.description": "Management system that minimizes environmental impacts",
  "iso.14001.benefits.1": "Environmental risk reduction",
  "iso.14001.benefits.2": "Energy savings",
  "iso.14001.benefits.3": "Waste management",
  "iso.14001.benefits.4": "Legal compliance",

  "iso.45001.description": "System for protecting employee health and safety",
  "iso.45001.benefits.1": "Reduction in workplace accidents",
  "iso.45001.benefits.2": "Employee safety",
  "iso.45001.benefits.3": "Risk assessment",
  "iso.45001.benefits.4": "Meeting legal obligations",

  "iso.50001.description": "Management system that increases energy efficiency",
  "iso.50001.benefits.1": "Reduction in energy costs",
  "iso.50001.benefits.2": "Carbon footprint reduction",
  "iso.50001.benefits.3": "Energy performance improvement",
  "iso.50001.benefits.4": "Sustainability",

  "iso.10002.description": "System for effective management of customer complaints",
  "iso.10002.benefits.1": "Increased customer loyalty",
  "iso.10002.benefits.2": "Complaint resolution process",
  "iso.10002.benefits.3": "Customer feedback",
  "iso.10002.benefits.4": "Service quality improvement",

  "iso.27001.description": "Information asset protection and security management",
  "iso.27001.benefits.1": "Data security",
  "iso.27001.benefits.2": "Cyber attack protection",
  "iso.27001.benefits.3": "Confidentiality assurance",
  "iso.27001.benefits.4": "Legal compliance",

  "iso.27701.description": "KVKV and GDPR compliant personal data protection system",
  "iso.27701.benefits.1": "KVKV compliance",
  "iso.27701.benefits.2": "Personal data security",
  "iso.27701.benefits.3": "Privacy management",
  "iso.27701.benefits.4": "Legal risk reduction",

  "iso.31000.description": "Systematic management of corporate risks",
  "iso.31000.benefits.1": "Risk identification",
  "iso.31000.benefits.2": "Risk assessment",
  "iso.31000.benefits.3": "Risk reduction strategies",
  "iso.31000.benefits.4": "Decision-making processes",

  "iso.39001.description": "Management system that increases traffic safety",
  "iso.39001.benefits.1": "Reduction in traffic accidents",
  "iso.39001.benefits.2": "Driver safety",
  "iso.39001.benefits.3": "Vehicle fleet management",
  "iso.39001.benefits.4": "Safety culture",

  "iso.28001.description": "Supply chain security management system",
  "iso.28001.benefits.1": "Supply security",
  "iso.28001.benefits.2": "Logistics security",
  "iso.28001.benefits.3": "Risk management",
  "iso.28001.benefits.4": "Operational continuity",

  "iso.22301.description": "Management system that ensures business continuity",
  "iso.22301.benefits.1": "Business continuity planning",
  "iso.22301.benefits.2": "Crisis management",
  "iso.22301.benefits.3": "Operational resilience",
  "iso.22301.benefits.4": "Rapid recovery",

  // Implementation Process
  "implementation.title": "Implementation Process",
  "implementation.subtitle": "We successfully implement your management systems with our systematic approach",
  "implementation.step1.title": "Current State Analysis",
  "implementation.step1.description": "Assessment of the organization's current state and gap analysis",
  "implementation.step2.title": "System Design",
  "implementation.step2.description": "Design of management system compliant with ISO standard",
  "implementation.step3.title": "Documentation",
  "implementation.step3.description": "Preparation of policies, procedures and instructions",
  "implementation.step4.title": "Training and Implementation",
  "implementation.step4.description": "Personnel training and system implementation",
  "implementation.step5.title": "Internal Audit",
  "implementation.step5.description": "Control of system effectiveness through internal audits",
  "implementation.step6.title": "Certification Audit",
  "implementation.step6.description": "Certification audit by independent organization",

  // Why Choose ISO
  "why.iso.title": "Why ISO Management Systems?",
  "why.iso.subtitle": "Increase your organization's performance with ISO standards",
  "why.iso.recognition.title": "International Recognition",
  "why.iso.recognition.description": "Valid certification in global markets",
  "why.iso.improvement.title": "Process Improvement",
  "why.iso.improvement.description": "Increase in operational efficiency",
  "why.iso.risk.title": "Risk Management",
  "why.iso.risk.description": "Proactive risk identification and management",
  "why.iso.trust.title": "Customer Trust",
  "why.iso.trust.description": "Increased customer satisfaction and loyalty",

  // CTA Section
  "cta.iso.title": "Start ISO Management System Implementation",
  "cta.iso.description": "Our expert consultants help you determine the most suitable ISO standard and implement it successfully.",
  "cta.consultation": "Free Consultation",
  "cta.quote": "Get Quote",

  // General
  "iso.standards.title": "ISO Management Systems",
  "iso.standards.subtitle": "Prepare your business for the future with management systems at international standards",
  "benefits.title": "Benefits:",

  // Certificate Showcase
  "showcase.badge": "International Certificates",
  "showcase.title": "Globally Recognized Certification Standards",
  "showcase.description": "Take your business to global standards with our internationally valid certificates covering GMP, HACCP, ISO and more.",
  "showcase.point1": "ISO 9001, ISO 14001, ISO 45001 and more",
  "showcase.point2": "HACCP, GMP food safety certification",
  "showcase.point3": "SCC, GSTC international certificates",
  "showcase.point4": "Fast and reliable certification process",

  // Achievement Section
  "achievement.badge": "Corporate Achievements",
  "achievement.title": "International Recognition and Success",
  "achievement.subtitle": "As IQ CERT, we are a trusted reference point in the industry with our achievements and accreditations in the international arena.",
  "achievement.caption": "IQ PCC-PYB Certificate Ceremony",
  "achievement.description": "Our certification competence approved by international accreditation organizations enables us to provide the highest quality assurance to our customers.",
  "achievement.caption2": "Zengezur University Certificate Ceremony",
  "achievement.description2": "At the certificate ceremony held within the scope of our international collaborations, certificates approved by IQ CERT were presented to participants.",
  "achievement.caption3": "ULAK Collaboration and Solution Partnership",
  "achievement.description3": "Through our strategic collaboration with ULAK General Manager Fatih Sinan Yılmaz, we are enhancing our service quality in international accreditation standards.",
  "achievement.stat1": "Country Validity",
  "achievement.stat2": "Certificates Issued",
  "achievement.stat3": "Years of Experience",
  "achievement.stat4": "Customer Satisfaction"
};

export default en;
